import Vue from 'vue';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAngleDown, faAngleLeft, faAngleUp, faAngleRight, faDownload, faEyeSlash, faFileSignature, faFolder, faHistory, faPencilRuler, faSign, faSignInAlt, faStoreAlt, faUser,
} from '@fortawesome/free-solid-svg-icons';
import { faCheckCircle } from '@fortawesome/free-regular-svg-icons';

library.add(faAngleDown, faAngleLeft, faAngleUp, faAngleRight, faDownload, faEyeSlash, faFileSignature, faFolder, faHistory, faPencilRuler, faSign, faSignInAlt, faStoreAlt, faUser);
library.add(faCheckCircle);

Vue.component('font-awesome-icon', FontAwesomeIcon);
